import axiosWithToken from "axiosWithToken";
import {
  SendMessagePayload,
  Thread,
  ThreadDetailsResponse,
  ThreadMessageResponse,
  UnreadMessageCountResponse,
} from "./types";

const API_URL = process.env.REACT_APP_API_URL;

export const getUnreadMessageCount =
  async (): Promise<UnreadMessageCountResponse> => {
    try {
      const response = await axiosWithToken.get<UnreadMessageCountResponse>(
        `${API_URL}api/threads/unread-messages/count`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching unread notification count:", error);
      throw error;
    }
  };

export const getThreads = async (): Promise<Thread[]> => {
  const response = await axiosWithToken.get<Thread[]>(`${API_URL}api/threads`);
  return response.data;
};

export const getThreadDetails = async (
  threadId: string
): Promise<ThreadDetailsResponse> => {
  const response = await axiosWithToken.get<ThreadDetailsResponse>(
    `${API_URL}api/threads/${threadId}`
  );
  return response.data;
};

export const getThreadMessages = async (
  threadId: string
): Promise<ThreadMessageResponse[]> => {
  const response = await axiosWithToken.get<ThreadMessageResponse[]>(
    `${API_URL}api/threads/${threadId}/messages`
  );
  return response.data;
};

export const sendThreadMessage = async (
  threadId: string,
  payload: SendMessagePayload
): Promise<void> => {
  await axiosWithToken.post(
    `${API_URL}api/threads/${threadId}/messages`,
    payload
  );
};

export const markAllThreadsAsDelivered = async (
  threadIds: string[]
): Promise<void> => {
  if (!threadIds.length) return;

  await axiosWithToken.put(`${API_URL}api/threads/messages/delivered`, {
    threadIds,
  });
};

export const markAllMessagesAsRead = async (
  threadId: string
): Promise<void> => {
  await axiosWithToken.put(`${API_URL}api/threads/${threadId}/messages/read`);
};

export const markThreadAsPin = async (
  threadId: string,
  isPinned: boolean
): Promise<void> => {
  await axiosWithToken.patch(`${API_URL}api/threads/${threadId}/pin`, {
    isPinned,
  });
};

export const archiveThread = async (
  threadId: string,
  isArchived: boolean
): Promise<void> => {
  await axiosWithToken.patch(`${API_URL}api/threads/${threadId}/archive`, {
    isArchived,
  });
};

export const blockUser = async (userId: string): Promise<void> => {
  await axiosWithToken.post(`${API_URL}api/user/${userId}/blocks`);
};

export const unblockUser = async (userId: string): Promise<void> => {
  await axiosWithToken.delete(`${API_URL}api/user/${userId}/blocks`);
};

export const updateThreadTitle = async (
  threadId: string,
  title: string
): Promise<boolean> => {
  const response = await axiosWithToken.patch<boolean>(
    `${API_URL}api/threads/${threadId}/update`,
    { title }
  );
  return response.data;
};
